import {BehaviorSubject, Observable} from 'rxjs';

export abstract class AbstractHideShow {
  private _events = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  public show() {
    this._events.next(true);
  }

  public hide() {
    this._events.next(false);
  }

  public status(): Observable<boolean> {
    return this._events.asObservable();
  }

}
